import React, { Component } from "react";
import { checkPersonalCellPhoneCode } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { connect } from "react-redux";

class MobileCode extends Component {
  state = {
    verificationCode: "",
    codeCheckedResult: null,
    errorMessage: "",
  };

  handleInput = (e) => {
    this.setState({
      verificationCode: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.checkPersonalCellPhoneCode(
      this.state.verificationCode,
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };
  onSuccess = (res) => {
    console.log(res);
    this.setState({ codeCheckedResult: res.data.success, errorMessage: "" });
    this.props.onProcessEnd();
  };
  onError = (err) => {
    console.log(err);
    this.setState({ errorMessage: err.response.data.message });
    this.props.onProcessEnd();
  };

  renderStatus = () => {
    if (this.state.codeCheckedResult) {
      return <div>Başarılı!</div>;
    }

    if (this.state.errorMessage) {
      return <div>{this.state.errorMessage}</div>;
    }
  };

  render() {
    return (
      <>
        {this.renderStatus()}
        <div>Telefonunuza gelen kod : </div>
        <div>
          <input
            type="text"
            onChange={this.handleInput}
            value={this.state.verificationCode}
          ></input>
          <button type="submit" onClick={this.handleSubmit}>
            Doğrula
          </button>
        </div>
      </>
    );
  }
}

export default connect(null, { checkPersonalCellPhoneCode })(
  containsLongRunningProcess(MobileCode)
);
